{
  "newAnnouncement": "有新公告",
  "notification": "通知和公告",
  "unread": "未读通知"
}
